import { post } from '..';

const sendChatMessage = async (
  message: string,
  buildingId: string,
  sessionId?: string,
) => post(
  'chatbot-api/chat-message',
  {
    message,
    buildingId,
    ...(sessionId !== undefined) && { sessionId },
  },
);

export default sendChatMessage;
